// src/components/AvatarPickerModal.jsx
import React, { useState } from 'react';

const avatars = Array.from({ length: 9 }, (_, i) => `https://i.pravatar.cc/150?u=${i + 1}`);

const AvatarPickerModal = ({ onClose, onSave }) => {
  const [selectedAvatar, setSelectedAvatar] = useState(null);

  const handleSave = () => {
    onSave(selectedAvatar); // Llama a la función onSave que le pasamos desde ProfileView
    onClose();
  };

  return (
    <>
      <div className="settings-overlay" onClick={onClose}></div>
      <div className="confirmation-modal">
        <h3>Elegir un Avatar</h3>
        <div className="avatar-grid">
          {avatars.map(avatarUrl => (
            <img 
              key={avatarUrl}
              src={avatarUrl}
              alt="Avatar"
              className={`avatar-item ${selectedAvatar === avatarUrl ? 'selected' : ''}`}
              onClick={() => setSelectedAvatar(avatarUrl)}
            />
          ))}
        </div>
        <div className="modal-footer">
          <button className="profile-button" onClick={onClose}>Cancelar</button>
          <button className="profile-button profile-button--primary" onClick={handleSave} disabled={!selectedAvatar}>
            Confirmar
          </button>
        </div>
      </div>
    </>
  );
};

export default AvatarPickerModal;